import { coreInitiativesTasksGetAsyncSlice } from './get';
import { coreInitiativesTasksPostAsyncSlice } from './post';

export const { requestGetCoreInitiativesTasks, resetGetCoreInitiativesTasks } =
	coreInitiativesTasksGetAsyncSlice.asyncActionCreators;

export const { requestPostCoreInitiativesTasks, resetPostCoreInitiativesTasks } =
	coreInitiativesTasksPostAsyncSlice.asyncActionCreators;

export * from './_id/actions';
export * from './link/actions';
export * from './order/actions';
